import React from "react";
import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import AddIcon from "@mui/icons-material/Add";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import axios from "axios";
import SweetAlert from "react-bootstrap-sweetalert";
import Pagination from "../../Pagination/Pagination";
import { useAppContext } from "../../Lib/ContextLib";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";
import EmptyState from "../../Components/EmptyState";
import moment from "moment";

const PERMISSION_CONFIG = [
  {
    category: "DASHBOARD",
    modules: [
      {
        name: "Dashboard",
        readKeys: ["dashboardCount"],
        writeKeys: ["dashboardCount"]
      }
    ]
  },
  {
    category: "ADMINS",
    modules: [
      {
        name: "Admins",
        readKeys: ["getAdminList"],
        writeKeys: ["getAdminList", "adminListAdd", "adminListEdit", "adminListDelete"]
      },
      {
        name: "Admin Access",
        readKeys: ["adminAccessUser"],
        writeKeys: ["adminAccessUser"]
      }
    ]
  },
  {
    category: "USERS",
    modules: [
      {
        name: "Total Users",
        readKeys: ["getPlayerList"],
        writeKeys: ["getPlayerList", "playerListEdit", "playerListDelete"]
      },
      {
        name: "Active Users (App)",
        readKeys: ["getLivePlayerAppList"],
        writeKeys: ["getLivePlayerAppList"]
      },
      {
        name: "Active Users (Game)",
        readKeys: ["getLivePlayerGameList"],
        writeKeys: ["getLivePlayerGameList"]
      },
      {
        name: "Banned Users",
        readKeys: ["getPlayerBannedList"],
        writeKeys: ["getPlayerBannedList"]
      }
    ]
  },
  {
    category: "GAMES & TOURNAMENTS",
    modules: [
      {
        name: "Tournament List",
        readKeys: ["getEightBallPoolLiteTour"],
        writeKeys: ["getEightBallPoolLiteTour"]
      },
      {
        name: "Block Blast",
        readKeys: ["getBlockBlastTour"],
        writeKeys: ["getBlockBlastTour", "addBlockBlastTour", "editBlockBlastTour", "deleteBlockBlastTour"]
      },
      {
        name: "Candy Cream",
        readKeys: ["getCandyCreamTour"],
        writeKeys: ["getCandyCreamTour", "addCandyCreamTour", "editCandyCreamTour", "deleteCandyCreamTour"]
      },
      {
        name: "Logic Line",
        readKeys: ["getLogicLineTour"],
        writeKeys: ["getLogicLineTour", "addLogicLineTour", "editLogicLineTour", "deleteLogicLineTour"]
      },
      {
        name: "Smash Block",
        readKeys: ["getSmashBlockTour"],
        writeKeys: ["getSmashBlockTour", "addSmashBlockTour", "editSmashBlockTour", "deleteSmashBlockTour"]
      }
    ]
  },
  {
    category: "CONTROLS",
    modules: [
      {
        name: "Banners",
        readKeys: ["getBannerList"],
        writeKeys: ["getBannerList", "bannerAdd", "bannerEdit", "bannerDelete"]
      },
      {
        name: "Coin Packages",
        readKeys: ["getCoinPackageList"],
        writeKeys: ["getCoinPackageList", "coinPackageAdd", "coinPackageEdit", "coinPackageDelete"]
      },
      {
        name: "Social",
        readKeys: ["getSocialList"],
        writeKeys: ["getSocialList", "editSocial"]
      },
      {
        name: "Versions",
        readKeys: ["getVersionList"],
        writeKeys: ["getVersionList", "versionEdit"]
      },
      {
        name: "Notifications",
        readKeys: ["getNotificationList"],
        writeKeys: ["getNotificationList", "notificationAdd", "notificationDelete"]
      },
      {
        name: "Notice",
        readKeys: ["getNoticeList"],
        writeKeys: ["getNoticeList", "noticeEdit"]
      },
      {
        name: "Bot Forms",
        readKeys: ["getBotForm"],
        writeKeys: ["getBotForm"]
      },
      {
        name: "Room Tiers",
        readKeys: ["getRoomTier"],
        writeKeys: ["getRoomTier"]
      },
      {
        name: "Restricted Area",
        readKeys: ["getRestrictedArea"],
        writeKeys: ["getRestrictedArea", "addRestrictedArea", "editRestrictedArea", "deleteRestrictedArea"]
      }
    ]
  },
  {
    category: "PAYMENTS & HISTORY",
    modules: [
      {
        name: "History",
        readKeys: ["getHistoryList"],
        writeKeys: ["getHistoryList"]
      },
      {
        name: "Add Cash List",
        readKeys: ["getAddCashList"],
        writeKeys: ["getAddCashList"]
      },
      {
        name: "Payout List",
        readKeys: ["getPayoutList"],
        writeKeys: ["getPayoutList"]
      },
      {
        name: "Bet List",
        readKeys: ["getBetList"],
        writeKeys: ["getBetList"]
      },
      {
        name: "Win List",
        readKeys: ["getWinList"],
        writeKeys: ["getWinList"]
      }
    ]
  },
  {
    category: "REPORTS",
    modules: [
      {
        name: "Player Reports",
        readKeys: ["getReportPlayerList"],
        writeKeys: ["getReportPlayerList"]
      },
      {
        name: "History Reports",
        readKeys: ["getReportHistoryList"],
        writeKeys: ["getReportHistoryList"]
      }
    ]
  }
];

export default function AdminList() {
  const { showPage, setShowPage, accessObject } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState([]);
  const [rowValue, setRowValue] = React.useState();
  const [openValue, setOpenValue] = React.useState(0);
  const [loader, setLoader] = React.useState(false);
  const [buttonLoader, setButtonLoader] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showPrePage, setShowPrePage] = React.useState(10);
  const [searchPermission, setSearchPermission] = React.useState("");
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });

  React.useEffect(() => {
    getBranch();
  }, []);

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };
  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };
  const LoginSchema = Yup.object().shape({
    name: Yup.string().required("required"),
    email: Yup.string().required("required"),
    password: Yup.string(),
  });

  const getBranch = async () => {
    setLoader(true);
    await axios(`${API_URL}/api/admin/auth/get-all-admin-list`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        console.log("response::: ", response);
        setLoader(false);
        setTableData(response.data.data || []);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
        setLoader(false);
      });
  };

  const clickEditButton = (item) => {
    setShowPage(true);
    console.log("item edit value :::", item);
    setRowValue(item);
    setOpenValue(2);
    setShowPassword(false);
    setSearchPermission("");
  };

  const openAddTournament = (value) => {
    setRowValue();
    console.log("openAddTournament :::", value);
    setShowPage(true);
    setOpenValue(value);
    setShowPassword(false);
    setSearchPermission("");
  };

  const updateTournament = (value) => {
    console.log("updateTournament value :::", value);
    const data = { ...value, id: rowValue._id };

    axios
      .patch(`${API_URL}/api/admin/auth/update-admin-data`, data)
      .then((res) => {
        console.log("update :::", res.data);
        if (res.data.status) {
          setButtonLoader(false);
          successEdit(res.data.message);
        }
      })
      .catch((err) => {
        console.log("update err :::", err);
        setButtonLoader(false);
      });
  };

  const addNewTournament = (value) => {
    console.log("addNewTournament value :::", value, openValue, rowValue);
    axios(`${API_URL}/api/admin/auth/signup`, {
      method: "POST",
      credentials: "include",
      data: value,
    })
      .then((result) => {
        console.log("handleSubmit result :::", result.data);
        if (result.data.status) {
          successAdd(result.data.message);
        } else {
          setButtonLoader(false);
          setAlert(
            <SweetAlert
              error
              style={{ display: "block" }}
              title={<h4>{result.data.message}</h4>}
              onConfirm={() => {
                setAlert(null);
              }}
              confirmBtnBsStyle="danger"
            ></SweetAlert>
          );
        }
        setButtonLoader(false);
      })
      .catch((err) => {
        console.log("handleSubmit err :::", err);
      });
  };

  const warningWithConfirmMessage = (e) => {
    console.log("donw");
    setAlert(
      <SweetAlert
        custom
        showCancel
        confirmBtnText="Yes, Delete"
        cancelBtnText="Cancel"
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        onConfirm={() => {
          deleteData(e);
          setAlert(null);
        }}
        onCancel={() => setAlert(null)}
        customClass="premium-alert"
        btnSize="md"
        confirmBtnClass="premium-alert-confirm bg-danger shadow-danger"
        cancelBtnClass="premium-alert-cancel"
        customIcon={<div className="mb-4" style={{ fontSize: '50px', color: '#dc3545' }}><i className="fas fa-trash-alt"></i></div>}
        title=""
      >
        <div className="premium-alert-title">Are you sure?</div>
        <p className="premium-alert-text">You are about to delete <b>{e.name}</b>. This action cannot be undone.</p>
      </SweetAlert>
    );
  };

  const successDeleted = (msg) => {
    console.log("donw");
    setAlert(
      <SweetAlert
        success
        title="Success"
        onConfirm={() => {
          getBranch();
          setAlert(null);
        }}
        customClass="premium-alert"
        confirmBtnClass="premium-alert-confirm"
      >
        <div className="premium-alert-title">Deleted!</div>
        <p className="premium-alert-text">{msg}</p>
      </SweetAlert>
    );
  };

  const deleteData = (e) => {
    axios
      .delete(`${API_URL}/api/admin/auth/delete-admin/${e._id}`)
      .then((res) => {
        console.log("delete res...", res.data);
        if (res.data.status) {
          successDeleted(res.data.message);
        }
        getBranch();
      });
  };

  const successAdd = (msg) => {
    console.log("donw");
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title={<h4>{msg}</h4>}
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      ></SweetAlert>
    );
  };

  const successEdit = (msg) => {
    console.log("donw");
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title={<h4>{msg}</h4>}
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      ></SweetAlert>
    );
  };

  return (
    <>
      {alert}
      {showPage ? (
        <div className="content p-3" style={{ height: "calc(100vh - 80px)", display: "flex", flexDirection: "column" }}>
          <div className="card shadow-sm" style={{ borderRadius: "16px", flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", backgroundColor: "#fff", border: "none" }}>
            <Box sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column" }}>
              <Formik
                initialValues={{
                  name: rowValue ? rowValue?.name : "",
                  email: rowValue ? rowValue?.email : "",
                  password: rowValue ? rowValue?.password : "",
                  role: rowValue && rowValue.role !== undefined ? Number(rowValue.role) : 0,
                  access: rowValue && Array.isArray(rowValue.access) ? rowValue.access : [],
                }}
                validationSchema={LoginSchema}
                onSubmit={(values) => {
                  setButtonLoader(true);
                  console.log("update formik value :::", values, openValue);
                  if (openValue === 1) {
                    addNewTournament(values);
                  }
                  if (openValue === 2) {
                    updateTournament(values);
                  }
                }}
              >
                {({ touched, errors, values, setFieldValue }) => (
                  <Form style={{ display: "flex", flexDirection: "column", height: "100%" }}>
                    <div style={{ flex: 1, overflowY: "auto", padding: "30px", backgroundColor: "#fff" }}>
                      
                      <div className="mb-5">
                        <h5 className="font-weight-bold mb-4" style={{ color: "#333" }}>General Info</h5>
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <label style={{ fontWeight: 500, color: "#555" }}>Full name <span className="text-danger">*</span></label>
                              <Field
                                type="text"
                                name="name"
                                className={`mt-1 form-control ${touched.name && errors.name ? "is-invalid" : ""}`}
                                style={{ borderRadius: "8px", border: "1px solid #ddd", padding: "10px" }}
                              />
                              <ErrorMessage component="div" name="name" className="invalid-feedback" />
                            </div>
                          </div>
                          
                          <div className="col-md-4">
                            <div className="form-group">
                              <label style={{ fontWeight: 500, color: "#555" }}>Email <span className="text-danger">*</span></label>
                              <Field
                                type="email"
                                name="email"
                                className={`mt-1 form-control ${touched.email && errors.email ? "is-invalid" : ""}`}
                                style={{ borderRadius: "8px", border: "1px solid #ddd", padding: "10px" }}
                              />
                              <ErrorMessage component="div" name="email" className="invalid-feedback" />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label style={{ fontWeight: 500, color: "#555" }}>Password {openValue === 1 && <span className="text-danger">*</span>}</label>
                              <div className="position-relative mt-1">
                                <Field
                                  type={showPassword ? "text" : "password"}
                                  name="password"
                                  className={`form-control ${touched.password && errors.password ? "is-invalid" : ""}`}
                                  style={{ borderRadius: "8px", border: "1px solid #ddd", padding: "10px", paddingRight: '40px' }}
                                />
                                <div
                                  onClick={() => setShowPassword(!showPassword)}
                                  style={{
                                    position: 'absolute',
                                    right: '12px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                    color: '#6c757d',
                                    zIndex: 10,
                                    display: 'flex',
                                    alignItems: 'center'
                                  }}
                                >
                                  {showPassword ? (
                                    <VisibilityOff style={{ fontSize: '1.2rem' }} />
                                  ) : (
                                    <Visibility style={{ fontSize: '1.2rem' }} />
                                  )}
                                </div>
                              </div>
                              <ErrorMessage component="div" name="password" className="invalid-feedback d-block" />
                              {openValue === 2 && <small className="text-muted">Leave blank to keep existing password</small>}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="mb-4">
                        <h5 className="font-weight-bold mb-4" style={{ color: "#333" }}>Role & access</h5>
                        
                        {/* Toggle Pill */}
                        <div className="d-flex mb-4" style={{ backgroundColor: "#f1f5f9", padding: "4px", borderRadius: "10px", display: "inline-flex", width: "max-content" }}>
                          <button 
                            type="button" 
                            onClick={() => setFieldValue("role", 0)} 
                            style={{ 
                              padding: "8px 20px", 
                              borderRadius: "8px", 
                              border: "none", 
                              backgroundColor: values.role === 0 ? "#fff" : "transparent", 
                              boxShadow: values.role === 0 ? "0 2px 4px rgba(0,0,0,0.05)" : "none", 
                              fontWeight: values.role === 0 ? "600" : "500", 
                              color: values.role === 0 ? "#0f172a" : "#64748b",
                              transition: "all 0.2s"
                            }}
                          >
                            Admin
                          </button>
                          <button 
                            type="button" 
                            onClick={() => setFieldValue("role", 1)} 
                            style={{ 
                              padding: "8px 20px", 
                              borderRadius: "8px", 
                              border: "none", 
                              backgroundColor: values.role === 1 ? "#fff" : "transparent", 
                              boxShadow: values.role === 1 ? "0 2px 4px rgba(0,0,0,0.05)" : "none", 
                              fontWeight: values.role === 1 ? "600" : "500", 
                              color: values.role === 1 ? "#0f172a" : "#64748b",
                              transition: "all 0.2s"
                            }}
                          >
                            Manager
                          </button>
                        </div>

                        {/* Manager Permissions Table */}
                        {Number(values.role) === 1 && (
                          <div className="border rounded-lg" style={{ borderRadius: "12px", overflow: "hidden", border: "1px solid #e2e8f0" }}>
                            <table className="table table-borderless mb-0" style={{ backgroundColor: "#fff" }}>
                              <thead style={{ backgroundColor: "#f8fafc", borderBottom: "1px solid #e2e8f0" }}>
                                <tr>
                                  <th style={{ width: "60%", color: "#334155", fontWeight: "600", padding: "16px 24px" }}>
                                    <div className="d-flex align-items-center">
                                      <div style={{ width: "16px", height: "16px", borderRadius: "4px", backgroundColor: "#334155", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px" }}>
                                        <i className="fas fa-minus" style={{ color: "#fff", fontSize: "10px" }}></i>
                                      </div>
                                      Module
                                    </div>
                                  </th>
                                  <th className="text-center" style={{ width: "20%", color: "#334155", fontWeight: "600", padding: "16px 24px" }}>
                                    <div className="d-flex align-items-center justify-content-center">
                                      <div style={{ width: "16px", height: "16px", borderRadius: "4px", backgroundColor: "#334155", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px" }}>
                                        <i className="fas fa-minus" style={{ color: "#fff", fontSize: "10px" }}></i>
                                      </div>
                                      Read
                                    </div>
                                  </th>
                                  <th className="text-center" style={{ width: "20%", color: "#334155", fontWeight: "600", padding: "16px 24px" }}>
                                    <div className="d-flex align-items-center justify-content-center">
                                      <div style={{ width: "16px", height: "16px", borderRadius: "4px", backgroundColor: "#334155", display: "flex", alignItems: "center", justifyContent: "center", marginRight: "12px" }}>
                                        <i className="fas fa-minus" style={{ color: "#fff", fontSize: "10px" }}></i>
                                      </div>
                                      Write
                                    </div>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {PERMISSION_CONFIG.map((cat, catIdx) => (
                                  <React.Fragment key={catIdx}>
                                    {cat.modules.map((mod, modIdx) => {
                                      const currentAccess = values.access || [];
                                      const pureWriteKeys = mod.writeKeys.filter(k => !mod.readKeys.includes(k));
                                      const hasRead = mod.readKeys.every(k => currentAccess.includes(k));
                                      const isOnlyRead = mod.readKeys.length === mod.writeKeys.length && mod.readKeys.every(k => mod.writeKeys.includes(k));
                                      const hasAllWrite = isOnlyRead 
                                          ? currentAccess.includes(`${mod.name}_WRITE`)
                                          : (pureWriteKeys.length > 0 
                                              ? pureWriteKeys.every(k => currentAccess.includes(k)) 
                                              : mod.writeKeys.every(k => currentAccess.includes(k)));
                                      
                                      let status = "None";
                                      if (hasAllWrite && (mod.writeKeys.length > 0 || isOnlyRead)) {
                                        status = "Write";
                                      } else if (hasRead && mod.readKeys.length > 0) {
                                        status = "Read";
                                      }

                                      return (
                                        <tr key={`${catIdx}-${modIdx}`} style={{ borderBottom: "1px solid #f1f5f9" }}>
                                          <td className="align-middle" style={{ padding: "16px 24px" }}>
                                            <div className="d-flex align-items-center">
                                              <span style={{ fontWeight: "500", color: "#475569" }}>{mod.name}</span>
                                            </div>
                                          </td>
                                          <td className="align-middle text-center" style={{ padding: "16px 24px" }}>
                                            <div className="d-flex justify-content-center">
                                              <div 
                                                className="d-flex align-items-center justify-content-center"
                                                style={{
                                                  width: "20px", height: "20px",
                                                  borderRadius: "6px",
                                                  backgroundColor: status === "Read" ? "#0f172a" : "#fff",
                                                  border: status === "Read" ? "none" : "2px solid #cbd5e1",
                                                  cursor: "pointer",
                                                  transition: "all 0.2s"
                                                }}
                                                onClick={() => {
                                                  const newStatus = status === "Read" ? "None" : "Read";
                                                  let updatedAccess = [...currentAccess];
                                                  const allModuleKeys = [...mod.readKeys, ...mod.writeKeys];
                                                  if (isOnlyRead) allModuleKeys.push(`${mod.name}_WRITE`);
                                                  
                                                  updatedAccess = updatedAccess.filter(k => !allModuleKeys.includes(k));
                                                  
                                                  if (newStatus === "Read") {
                                                    mod.readKeys.forEach(k => {
                                                      if (!updatedAccess.includes(k)) updatedAccess.push(k);
                                                    });
                                                  }
                                                  
                                                  setFieldValue("access", updatedAccess);
                                                }}
                                              >
                                                {status === "Read" && <i className="fas fa-check" style={{ color: "#fff", fontSize: "12px" }}></i>}
                                              </div>
                                            </div>
                                          </td>
                                          <td className="align-middle text-center" style={{ padding: "16px 24px" }}>
                                            <div className="d-flex justify-content-center">
                                              <div 
                                                className="d-flex align-items-center justify-content-center"
                                                style={{
                                                  width: "20px", height: "20px",
                                                  borderRadius: "6px",
                                                  backgroundColor: status === "Write" ? "#0f172a" : "#fff",
                                                  border: status === "Write" ? "none" : "2px solid #cbd5e1",
                                                  cursor: "pointer",
                                                  transition: "all 0.2s"
                                                }}
                                                onClick={() => {
                                                  const newStatus = status === "Write" ? "None" : "Write";
                                                  let updatedAccess = [...currentAccess];
                                                  const allModuleKeys = [...mod.readKeys, ...mod.writeKeys];
                                                  if (isOnlyRead) allModuleKeys.push(`${mod.name}_WRITE`);
                                                  
                                                  updatedAccess = updatedAccess.filter(k => !allModuleKeys.includes(k));
                                                  
                                                  if (newStatus === "Write") {
                                                    [...mod.readKeys, ...mod.writeKeys].forEach(k => {
                                                      if (!updatedAccess.includes(k)) updatedAccess.push(k);
                                                    });
                                                    if (isOnlyRead) updatedAccess.push(`${mod.name}_WRITE`);
                                                  }
                                                  
                                                  setFieldValue("access", updatedAccess);
                                                }}
                                              >
                                                {status === "Write" && <i className="fas fa-check" style={{ color: "#fff", fontSize: "12px" }}></i>}
                                              </div>
                                            </div>
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </React.Fragment>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="d-flex p-4 justify-content-end align-items-center" style={{ backgroundColor: "#fff", borderTop: "1px solid #f1f5f9" }}>
                      <button
                        onClick={() => setShowPage(false)}
                        type="button"
                        className="btn font-weight-bold mr-3"
                        style={{
                          minWidth: '100px',
                          height: '42px',
                          borderRadius: '8px',
                          backgroundColor: '#fff',
                          color: '#475569',
                          border: '1px solid #e2e8f0'
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn font-weight-bold d-flex align-items-center justify-content-center"
                        style={{
                          minWidth: '100px',
                          height: '42px',
                          backgroundColor: '#0f172a',
                          color: '#fff',
                          border: 'none',
                          borderRadius: '8px'
                        }}
                        disabled={buttonLoader}
                      >
                        Save
                        {buttonLoader && (
                          <div
                            className="spinner-border ml-2"
                            role="status"
                            style={{ height: "14px", width: "14px" }}
                          />
                        )}
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </Box>
          </div>
        </div>
      ) : (
        <div className="content p-3">
          <div className="card " style={{ borderRadius: "16px" }}>
            <div className="pl-4 pr-4 pt-4">
              <div className="row justify-content-end">
                <div className="col-md-6 d-flex justify-content-end">
                  <button
                    onClick={() => {
                      if (accessObject?.adminListAdd === true) {
                        openAddTournament(1);
                      }
                    }}
                    type="button"
                    className="btn btn-primary"
                    style={{ 
                      borderRadius: "10px",
                      opacity: accessObject?.adminListAdd === true ? 1 : 0.5,
                      cursor: accessObject?.adminListAdd === true ? "pointer" : "not-allowed"
                    }}
                    disabled={!accessObject?.adminListAdd}
                  >
                    <AddIcon className="mr-1" />
                    Add New Admin
                  </button>
                </div>
              </div>
            </div>

            <div className="card-body" style={{ overflow: "scroll" }}>
              <table id="" className="table table-bordered table-striped">
                <thead>
                  <tr>
                    <th>SrNo</th>
                    <th>Date</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {accessObject?.getAdminList === true ? (
                    !loader ? (
                      <>
                        {(tableData || []).length > 0 ? (
                          <>
                            {tableData
                              ?.slice(pagination.start, pagination.end)
                              .map((item, index) => (
                                <tr key={index}>
                                  <td>{index + 1 + pagination.start}</td>
                                  <td>
                                    {moment(item.createdAt).format(
                                      "DD/MM/YYYY"
                                    )}
                                  </td>
                                  <td>{item.name}</td>
                                  <td>{item.email}</td>
                                  <td>
                                    <span 
                                      className={`badge ${Number(item.role) === 1 ? 'badge-info bg-info text-white' : 'badge-warning bg-warning text-dark'}`} 
                                      style={{ padding: "6px 12px", borderRadius: "8px", fontWeight: "bold" }}
                                    >
                                      {Number(item.role) === 1 ? 'Manager' : 'Admin'}
                                    </span>
                                  </td>

                                  <td className="d-flex justify-content-evenly ">
                                    <EditIcon
                                      className="mr-3 courser"
                                      style={{ 
                                        cursor: accessObject?.adminListEdit === true ? "pointer" : "not-allowed",
                                        opacity: accessObject?.adminListEdit === true ? 1 : 0.4
                                      }}
                                      onClick={() => {
                                        if (accessObject?.adminListEdit === true) clickEditButton(item);
                                      }}
                                    />
                                    <ClearIcon
                                      className="courser text-danger"
                                      style={{ 
                                        cursor: accessObject?.adminListDelete === true ? "pointer" : "not-allowed",
                                        opacity: accessObject?.adminListDelete === true ? 1 : 0.4
                                      }}
                                      onClick={() => {
                                        if (accessObject?.adminListDelete === true) warningWithConfirmMessage(item);
                                      }}
                                    />
                                  </td>
                                </tr>
                              ))}
                          </>
                        ) : (
                          <EmptyState colSpan={6} />
                        )}
                      </>
                    ) : (
                      ""
                    )
                  ) : (
                    <>
                      <tr className="text-center">
                        <td colSpan={6}>
                          <h5>Access Denied</h5>
                        </td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
              {accessObject?.getAdminList === true && (
                <div className="mt-4">{loader && <Loader />}</div>
              )}
            </div>
            {accessObject?.getAdminList === true && (tableData || []).length !== 0 && (
              <Pagination
                updateShowPerpagevalue={updateShowPerpagevalue}
                showPrePage={showPrePage}
                onPaginationChange={onPaginationChange}
                total={(tableData || []).length}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}
